import React from 'react';
import styled from 'styled-components';

// Shopee: E-commerce product listing style with sale badges, warm orange tones
const ShopeeTheme = ({ colorTheme }: { colorTheme: string }) => {
   return (
      <Wrapper>
         <Banner>
            <BannerText>🔥 HOT DEALS</BannerText>
         </Banner>
         <ProductGrid>
            <Product>
               <ProductBadge>BEST SELLER</ProductBadge>
               <ProductIcon>📶</ProductIcon>
               <ProductName>3 Hours</ProductName>
               <ProductDesc>Unlimited Internet</ProductDesc>
               <PriceRow>
                  <OldPrice>₱65</OldPrice>
                  <NewPrice>₱50</NewPrice>
               </PriceRow>
               <AddBtn>Add to Cart</AddBtn>
            </Product>
            <Product>
               <ProductIcon>📶</ProductIcon>
               <ProductName>1 Day</ProductName>
               <ProductDesc>Unlimited Internet</ProductDesc>
               <PriceRow>
                  <OldPrice>₱100</OldPrice>
                  <NewPrice>₱80</NewPrice>
               </PriceRow>
               <AddBtn>Add to Cart</AddBtn>
            </Product>
            <Product>
               <ProductIcon>📶</ProductIcon>
               <ProductName>3 Days</ProductName>
               <ProductDesc>Unlimited Internet</ProductDesc>
               <PriceRow>
                  <NewPrice>₱150</NewPrice>
               </PriceRow>
               <AddBtn>Add to Cart</AddBtn>
            </Product>
         </ProductGrid>
      </Wrapper>
   );
};

const Wrapper = styled.div``;
const Banner = styled.div`
   background: linear-gradient(135deg, #ee4d2d, #ff6633);
   border-radius: 6px; padding: 5px; margin-bottom: 6px; text-align: center;
`;
const BannerText = styled.p`font-size: 9px; font-weight: 700; color: white; letter-spacing: 0.5px;`;
const ProductGrid = styled.div`
   display: grid; grid-template-columns: repeat(3, 1fr); gap: 4px;
`;
const Product = styled.div`
   position: relative; background: white; border: 1px solid #ffd8cc;
   border-radius: 6px; padding: 6px; text-align: center;
`;
const ProductBadge = styled.div`
   position: absolute; top: 0; left: 0;
   background: #ee4d2d; color: white; font-size: 5px; font-weight: 700;
   padding: 1px 4px; border-radius: 6px 0 6px 0;
`;
const ProductIcon = styled.div`font-size: 16px; margin-bottom: 2px;`;
const ProductName = styled.p`font-size: 8px; font-weight: 700; color: #222;`;
const ProductDesc = styled.p`font-size: 6px; color: #888; margin-bottom: 3px;`;
const PriceRow = styled.div`display: flex; align-items: center; justify-content: center; gap: 3px; margin-bottom: 4px;`;
const OldPrice = styled.span`font-size: 7px; color: #999; text-decoration: line-through;`;
const NewPrice = styled.span`font-size: 10px; font-weight: 800; color: #ee4d2d;`;
const AddBtn = styled.div`
   background: #ee4d2d; color: white; font-size: 7px; font-weight: 600;
   padding: 3px; border-radius: 4px;
`;

export default ShopeeTheme;
